import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import apolloProvider from './services/apolloProvider.service'
// import './services/vueErrorHandlerService'
import SSO from '@/plugins/sso'
import { getSSOConfiguration } from './config'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

// Modules
import EventModule from './modules/event'
import TrainDeviationModule from './modules/trainDeviation'
import DelayModule from './modules/delay'
import TurnaroundModule from './modules/turnaround'
import ReplacementModule from './modules/replacement'
import YellowVestModule from './modules/yellowVest'
import TrafficMessageModule from './modules/trafficMessage'
import DuaMessageModule from './modules/duaMessage'
import MasterdataModule from './modules/masterdata'
import HistoryModule from './modules/history'
import LinkDeviationModule from './modules/linkDeviation'
import DuwaModule from './modules/duwa'
import OdocModule from './modules/odoc'
import RejectedStop from './modules/rejectedStop'
import CrewModule from './modules/crew'
import TibBannerModule from './modules/tibBanner'
import SmsMessageModule from './modules/smsMessage'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://59b00f54605e402488f303ae5c621b83@o261284.ingest.sentry.io/5521665',
    integrations: [
      new VueIntegration({
        Vue,
        attachProps: true
      }),
      new Integrations.BrowserTracing()
    ],
    tracesSampleRate: 1.0
  })
}
Vue.config.productionTip = false

Vue.prototype.$eventBus = new Vue()

const ssoConfig = getSSOConfiguration()

Vue.use(SSO, {
  ...ssoConfig,
  router,
  store
})

export const $sso = Vue.prototype.$sso

async function initVueApp() {
  return new Vue({
    router,
    store,
    vuetify,
    apolloProvider,
    render: h => h(App)
  }).$mount('#app')
}

function bootstrap() {
  new EventModule({ store })
  new TrainDeviationModule({ store })
  new DelayModule({ store })
  new TurnaroundModule({ store })
  new ReplacementModule({ store })
  new YellowVestModule({ store })
  new TrafficMessageModule({ store })
  new DuaMessageModule({ store })
  new MasterdataModule({ store })
  new HistoryModule({ store })
  new LinkDeviationModule({ store })
  new DuwaModule({ store })
  new OdocModule({ store })
  new TibBannerModule({ store })
  new RejectedStop({ store })
  new CrewModule({ store })
  new SmsMessageModule({ store })

  return initVueApp()
}

const instance = bootstrap()

export const $apollo = instance.$apollo
